import { useEffect } from "react";

function Policy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="max-w-7xl mx-auto flex flex-col mt-24 items-center justify-center">
        <div className="text-center px-4 sm:px-6 mt-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#353535]">
            Understand Our{" "}
            <span className="text-[#ca8032]">Privacy Policy</span>
          </h1>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg mt-2 sm:mt-3 max-w-xl mx-auto">
            Last update date: 06/11/2025
          </p>
        </div>


        <div className="max-w-4xl mx-auto p-4 space-y-4 text-[#006039]">
          {/* 1. Introduction */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">1. Introduction</h3>
            <p className="mb-2">
              Welcome to aombre Car Rental ("Company," "we," "our," or "us").
              Your privacy is important to us. This Privacy Policy explains how
              we collect, use, and protect your personal data when you use our
              services, including our website and rental services.
            </p>
            <p>
              By using our services, you agree to this policy's collection and
              use of information.
            </p>
          </div>

          {/* 2. Information We Collect */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              2. Information We Collect
            </h3>
            <p className="mb-2">
              We collect the following personal information when you use our
              services:
            </p>
            <ul className="list-disc list-inside mb-2 ml-4">
              <li>Name</li>
              <li>Email Address</li>
              <li>Phone Number</li>
            </ul>
            <p className="mb-2">
              Along with this additionally reservation number will automatically
              be created and also currency code with will be captured.
            </p>
            <p>
              This information is necessary to fulfill the rental agreement and
              provide our services. Additionally, if you provide consent, we may
              use your email to send marketing communications, including
              promotional offers and updates about our services.
            </p>
          </div>

          {/* 3. Purpose of Data Collection */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              3. Purpose of Data Collection
            </h3>
            <p className="mb-2">
              We collect and use your personal data for the following purposes:
            </p>
            <ul className="list-disc list-inside ml-4">
              <li>To process and fulfill your vehicle rental agreement.</li>
              <li>To communicate with you regarding your rental booking.</li>
              <li>To comply with legal and regulatory requirements.</li>
              <li>
                To send marketing communications if you have provided consent.
              </li>
            </ul>
          </div>

          {/* 4. Sharing of Data */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">4. Sharing of Data</h3>
            <p className="mb-2">We may share your personal information with:</p>
            <ul className="list-disc list-inside ml-4">
              <li>
                Our headquarters are in Canada & US to manage bookings and
                customer support.
              </li>
              <li>
                Third-party service providers who assist us in providing rental
                services (e.g., payment processors, customer support platforms).
              </li>
              <li>
                Legal authorities when required by law or to protect our rights.
              </li>
            </ul>
          </div>

          {/* 5. International Data Transfers */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              5. International Data Transfers
            </h3>
            <p>
              Since our headquarters is located in Canada, your personal data
              may be transferred outside of the European Economic Area (EEA). We
              ensure that appropriate safeguards are in place to protect your
              data, such as Standard Contractual Clauses (SCCs) or other legal
              mechanisms.
            </p>
          </div>

          {/* 6. Your Rights Under GDPR */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              6. Your Rights Under GDPR
            </h3>
            <p className="mb-2">
              If you are in the European Economic Area (EEA), you have the
              following rights under the General Data Protection Regulation
              (GDPR):
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-2">
              <li>
                <strong>Right to Access:</strong> Request a copy of the personal
                data we hold about you.
              </li>
              <li>
                <strong>Right to Rectification:</strong> Request correction of
                inaccurate or incomplete data.
              </li>
              <li>
                <strong>Right to Erasure:</strong> Request deletion of your data
                under certain conditions.
              </li>
              <li>
                <strong>Right to Restrict Processing:</strong> Request that we
                limit how we use your data.
              </li>
              <li>
                <strong>Right to Data Portability:</strong> Request transfer of
                your data to another service provider.
              </li>
              <li>
                <strong>Right to Object:</strong> Object to processing for
                marketing purposes.
              </li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at{" "}
              <a
                href="mailto:care@aombre.com"
                className="text-[#ca8032] underline"
              >
                care@aombre.com
              </a>
            </p>
          </div>

          {/* 7. Data Retention */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">7. Data Retention</h3>
            <p>
              We retain your personal data only for as long as necessary to
              fulfill the rental agreement and comply with legal obligations. If
              you have provided consent for marketing communications, we will
              retain your email until you opt out.
            </p>
          </div>

          {/* 8. Security Measures */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">8. Security Measures</h3>
            <p>
              We implement appropriate security measures to protect your data
              against unauthorized access, alteration, disclosure, or
              destruction.
            </p>
          </div>

          {/* 9. Changes to This Privacy Policy */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              9. Changes to This Privacy Policy
            </h3>
            <p>
              We may update this Privacy Policy from time to time. The latest
              version will always be available on our website.
            </p>
          </div>

          {/* 10. Contact Information */}
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-2">
              10. Contact Information
            </h3>
            <p className="mb-2">
              If you have any questions about this Privacy Policy or wish to
              exercise your rights, please contact us at:
            </p>
            <address className="not-italic space-y-1">
              <strong>aombre Car Rental</strong>
              <br />
              3035 Orlando Dr, Mississauga, ON L4V 1L6, Canada
              <br />
              Email:{" "}
              <a
                href="mailto:care@aombre.com"
                className="text-[#ca8032] underline"
              >
                care@aombre.com
              </a>
              <br />
              Phone:{" "}
              <a
                href="tel:+1-(888) 980-4410"
                className="text-[#ca8032] underline"
              >
                +1-(888) 980-4410
              </a>
            </address>
            <p className="mt-4">Thank you for choosing aombre Car Rental</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Policy;
